<template>
  <p
    v-if="errors.length > 0"
    :class="[`text-${color}`, { 'font-weight-bold': bold }]">
    {{ errors[0] }}
  </p>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: 'primary'
    },
    bold: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>